import { render, staticRenderFns } from "./OldVersionDialog.vue?vue&type=template&id=b9cb04be&scoped=true"
import script from "./OldVersionDialog.vue?vue&type=script&lang=js"
export * from "./OldVersionDialog.vue?vue&type=script&lang=js"
import style0 from "./OldVersionDialog.vue?vue&type=style&index=0&id=b9cb04be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9cb04be",
  null
  
)

export default component.exports